import { Grid } from "@mui/material"
import { ISettingsItem, useSettings } from "../../../Settings"
import { usePlan } from '../../../Plans'
import { useTranslation } from '../../../i18n'
import { SelectPlanDetails } from '../../'
import { ReactComponent as FirstSummaryIcon } from '../../../assets/icons/firstSummaryIcon.svg'

export default function FirstSummary({ name, variables }: ISettingsItem) {
  const { portability, smartControl } = usePlan()
  const { isSurfMVNE } = useSettings()
  const { t } = useTranslation()
  const defaultTextArray = [t.page2.summary.bonusTitle, t.page2.summary.bonusSubtitle]
  const { text = defaultTextArray } = variables || {}

  // Para MVNEs Surf não há bônus; esconder a seção inteira de "Bônus do Plano"
  if (isSurfMVNE) return null

  const portabilityVariables = {
    "text": [
      t.page2.summary.portability,
      '',
      t.page2.summary.portabilityDesc,
      '',
      t.page2.summary.portabilityBonus,
      '',
      '',
      '',
      '',
      '',
      '',
      'none',
      'none',
      '',
      'flex'
    ]
  }

  const smartControlVariables = {
    "text": [
      t.page2.summary.smartControl,
      t.page2.summary.smartControlDesc,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      'none',
      'none',
      '',
      'flex'
    ]
  }

  return (
    <Grid container item className={name ? `${name} first-summary` : "first-summary"} xs={12}>
      <Grid item className="titleArea" xs={12}>
        <Grid className="iconsArea">
          <FirstSummaryIcon />
        </Grid>
        <Grid className="textArea">
          <h3>{text[0]}</h3>
          <p>{text[1]}</p>
        </Grid>
      </Grid>
      <Grid container item className="ItemsArea" xs={12}>
        {portability && (
          <Grid item className="portabilityItem item">
            <SelectPlanDetails variables={portabilityVariables} />
          </Grid>
        )}
        {smartControl && (
          <Grid item className="smartControlItem item">
            <SelectPlanDetails variables={smartControlVariables} />
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}